import { useState, useEffect } from 'react';
import './App.css';

//refresh1

// ─── ICONS ──────────────────────────────────────────────────────────────────
const PhoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
    <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
    <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.105V5.383zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
  </svg>
);

const TikTokIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1 .05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
  </svg>
);

// ─── NAVBAR ──────────────────────────────────────────────────────────────────
function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = ['Home', 'Services', 'Notices', 'Gallery', 'Contact us'];
  const anchors = ['#home', '#services', '#notices', '#gallery', '#contact'];

  return (
    <nav className="navbar" style={scrolled ? { boxShadow: '0 4px 24px rgba(0,0,0,0.12)' } : {}}>
      <div className="navbar-inner">
        <a href="#home" className="navbar-logo">
          <img src="/Logo.png" alt="Company Logo" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
          <span className="navbar-logo-text">Creative Freightway<br />Logistics Pvt Ltd</span>
        </a>
        <ul className={`navbar-links${menuOpen ? ' open' : ''}`}>
          {navLinks.map((link, i) => (
            <li key={link}>
              <a href={anchors[i]} onClick={() => setMenuOpen(false)}>{link}</a>
            </li>
          ))}
        </ul>
        <button className="hamburger" onClick={() => setMenuOpen(m => !m)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}

// ─── HERO ─────────────────────────────────────────────────────────────────────
const heroImages = [
  '/hero-image1.png',
  '/hero-image2.png',
  '/hero-image3.png',
  '/hero-image4.png',
  '/hero-image5.png',
  '/hero-image6.png',
];

function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent(c => (c + 1) % heroImages.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="home" className="hero">
      {/* Slider track */}
      <div className="hero-slider-track" style={{ transform: `translateX(-${current * 100}%)` }}>
        {heroImages.map((src, i) => (
          <div
            key={i}
            className={`hero-slide${i === current ? ' active' : ''}`}
            style={{ backgroundImage: `url('${src}')` }}
          />
        ))}
      </div>

      {/* Dark gradient overlay */}
      <div className="hero-overlay" />

      {/* Content */}
      <div className="hero-content">
        <h1>Grow Your Business.<br />We Will Take Care<br />All Your Logistics</h1>
        <p>We are handling imports from China to Sri Lanka and Dubai To Sri Lanka &amp; China to Worldwide.</p>
        <a href="#contact" className="hero-btn">Contact Us</a>
      </div>


      {/* Dot indicators */}
      <div className="hero-dots">
        {heroImages.map((_, i) => (
          <button
            key={i}
            className={`hero-dot${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

// ─── ABOUT ────────────────────────────────────────────────────────────────────
function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-inner">
          <div className="about-text">
            <h2>Connect with Creative FreightWay Logistics Pvt Ltd</h2>
            <p>
              Welcome to Creative FreightWay Logistics Pvt Ltd, a partner for seamless shipping.
              We help Sri Lankan businesses and individuals import any type of goods from China and
              Dubai safely, quickly, cost-effectively. From sourcing guidance to customs clearance
              and doorstep delivery, our experienced team manages every step with transparency and care.
            </p>
          </div>
          <div className="about-images">
            <img
              src="/logistic-2.png"
              alt="Logistics containers"
              className="about-img-main"
            />
            <div className="about-img-logo">
              <img src="/Logo.jpg" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── SPECIAL NOTICES ─────────────────────────────────────────────────────────
const noticesData = [
  {
    title: 'Shipping Update – April 2025',
    body: 'We are pleased to announce that shipments from China will now depart every Monday and Thursday. Customers placing orders before Sunday midnight will be included in the next shipment. Please ensure all product details are submitted on time to avoid delays.',
  },
  {
    title: 'New Dubai Route Launched',
    body: 'Exciting news! Our Dubai to Sri Lanka route is now fully operational with weekly departures. We offer highly competitive rates for electronics, textiles, and general merchandise. Contact us today for a free quotation tailored to your import needs.',
  },
  {
    title: 'Customs Clearance Notice',
    body: 'Please be advised that all commercial shipments valued above LKR 500,000 require prior declaration. Our dedicated customs team is available to assist you with documentation, duties, and clearance procedures to ensure smooth delivery.',
  },
];

function SpecialNotices() {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive(a => (a + 1) % noticesData.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="notices" className="notices" style={{ background: "url('/Special-Notices.png') center/cover no-repeat" }}>
      <div className="container notices-inner">
        <h2>Special Notices</h2>
        <div className="notices-card">
          <h3>{noticesData[active].title}</h3>
          <p>{noticesData[active].body}</p>
        </div>
        <div className="notices-dots">
          {noticesData.map((_, i) => (
            <button
              key={i}
              className={`notices-dot${i === active ? ' active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Notice ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── SERVICES ────────────────────────────────────────────────────────────────
const servicesData = [
  {
    icon: '🚪',
    title: 'Door to Door Service',
    desc: 'We collect, ship, clear customs, and deliver directly to your home or warehouse anywhere in Sri Lanka.',
    img: '/Door-to-Door Service.png',
  },
  {
    icon: '🚢',
    title: 'Sea Freight',
    desc: 'Cost-effective cargo shipping for large and heavy goods. Ideal for business imports and bulk orders.',
    img: '/Sea-Freight.png',
  },
  {
    icon: '✈️',
    title: 'Air Freight',
    desc: 'Fast delivery for urgent shipments and high-value items.',
    img: '/Air-Freight.png',
  },
  {
    icon: '📋',
    title: 'Custom Clearance',
    desc: 'We handle all documentation and taxes so you don\'t have to worry about regulations.',
    img: '/Custom-Clearance.png',
  },
  {
    icon: '🛒',
    title: 'Buying Assistance',
    desc: 'Don\'t have a supplier? We help you purchase products safely from China suppliers and Dubai markets.',
    img: '/Buying-Assistance.png',
  },
  {
    icon: '🏢',
    title: 'Business Import Solutions',
    desc: 'Special packages for resellers, online sellers, and shops importing regularly.',
    img: '/Business-Import-Solutions.png',
  },
];

function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Services</h2>
        <div className="services-grid">
          {servicesData.map((s) => (
            <div className="service-card" key={s.title}>
              <span className="service-icon">{s.icon}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <img src={s.img} alt={s.title} className="service-card-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── HOW IT WORKS ─────────────────────────────────────────────────────────────
const steps = [
  { title: 'Send Us Product Details', desc: 'Share product link, photos, or description.', link: true },
  { title: 'Get Quotation', desc: 'We calculate shipping + taxes clearly.' },
  { title: 'We Handle Shipping', desc: 'Goods are shipped from China or Dubai to Sri Lanka.' },
  { title: 'Customs Clearance', desc: 'We process all required documents.' },
  { title: 'Delivery to You', desc: 'Receive your items safely at your doorstep.' },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-container">
          {steps.map((step, i) => (
            <div className="step-card" key={step.title}>
              <div className="step-number">{i + 1}</div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
              {step.link && <a href="#contact" className="step-link">Click Here</a>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── WHY CHOOSE US ────────────────────────────────────────────────────────────
const whyItems = [
  'Transparent pricing - No hidden charges',
  'Fast and secure shipping',
  'Experienced customs handling',
  'Support for personal & business imports',
  'Regular shipments every week',
  'Friendly customer support',
];

function WhyChooseUs() {
  return (
    <section id="why-choose" className="why-choose">
      <div className="container">
        <div className="why-inner">
          <div className="why-text">
            <h2>Why Choose Us</h2>
            <ul className="why-list">
              {whyItems.map(item => (
                <li className="why-item" key={item}>
                  <span className="why-item-dot" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <img
            src="/logistic-2.png"
            alt="Logistics"
            className="why-img"
          />
        </div>
      </div>
    </section>
  );
}

// ─── GALLERY ─────────────────────────────────────────────────────────────────
const galleryImages = [
  '/image-1.jpg',
  '/image-2.jpg',
  '/image-3.jpg',
  '/image-4.jpg',
  '/image-5.jpg',
  '/image-6.png',
];

function Gallery() {
  return (
    <section id="gallery" className="gallery">
      <div style={{ position: 'absolute', inset: 0, background: "url('/gallery.png') center/cover no-repeat", opacity: 0.06 }} />
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <h2 className="section-title">Gallery</h2>
        <div className="gallery-grid">
          {galleryImages.map((src, i) => (
            <div className="gallery-item" key={i}>
              <img src={src} alt={`Gallery ${i + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── OFFICE / MAP ─────────────────────────────────────────────────────────────
function OfficeMap() {
  return (
    <div className="office">
      <div className="office-info">
        <h2>Creative FreightWay Logistics Pvt Ltd Office</h2>
        <p>
          25A/1, Thoranawila junction, Makandana,<br />
          Kesbewa, Piliyandala,<br />
          Colombo, Sri Lanka
        </p>
      </div>
      <div className="office-map">
        <iframe
          title="Office Location"
          src="https://maps.google.com/maps?q=Creative+Fright+Way+Logistics+Pvt+Ltd,+Makandana,+Sri+Lanka&t=&z=15&ie=UTF8&iwloc=&output=embed"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}

// ─── FAQ ──────────────────────────────────────────────────────────────────────
const faqs = [
  {
    q: 'Can you import small items for personal use?',
    a: 'Yes, we import both personal packages and commercial cargo.',
  },
  {
    q: 'Do you handle customs taxes?',
    a: 'Yes, we calculate and clear all customs duties for you.',
  },
  {
    q: 'How long does shipping take?',
    a: 'Air freight: ~5–10 days \n Sea freight: ~20–35 days',
  },
  {
    q: 'Can you buy items on my behalf?',
    a: 'Yes, we provide purchasing assistance if needed.',
  },
];

function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <section id="faq" className="faq">
      <div className="container">
        <h2 className="section-title">FAQ</h2>
        <div className="faq-container">
          {faqs.map((faq, i) => (
            <div className={`faq-item${open === i ? ' open' : ''}`} key={i}>
              <button className="faq-question" onClick={() => setOpen(open === i ? null : i)}>
                {faq.q}
                <span className="faq-icon">⌄</span>
              </button>
              <div className="faq-answer">
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── CONTACT ─────────────────────────────────────────────────────────────────
const contactCards = [
  {
    icon: <PhoneIcon />,
    label: 'Call',
    links: [
      { text: '+94 71 205 5774', href: 'tel:+94712055774' },
      { text: '+94 75 205 5774', href: 'tel:+94752055774' },
      { text: '+94 11 349 6366', href: 'tel:+94113496366' }
    ],
    bg: '#00AEEF', color: 'white'
  },
  {
    icon: <WhatsAppIcon />,
    label: 'Whatsapp',
    links: [
      { text: '+94 71 205 5774', href: 'https://wa.me/94712055774' },
      { text: '+94 75 205 5774', href: 'https://wa.me/94752055774' }
    ],
    bg: '#25D366', color: 'white'
  },
  {
    icon: <FacebookIcon />,
    label: 'Facebook',
    links: [
      { text: '@Freightway', href: 'https://www.facebook.com/CFWL2021' }
    ],
    bg: '#1877F2', color: 'white'
  },
  {
    icon: <InstagramIcon />,
    label: 'Instagram',
    links: [
      { text: '@creativefreightway', href: 'https://www.instagram.com/creativefreightwaylogistics?igsh=a3BuaGJmMnoyNTl4' }
    ],
    bg: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)', color: 'white'
  },
  {
    icon: <TikTokIcon />,
    label: 'TikTok',
    links: [
      { text: '@creative_freightway', href: 'https://www.tiktok.com/@creative_freightwaylogis?_r=1&_t=ZS-94Bn3C0xZNE' }
    ],
    bg: '#010101', color: 'white'
  },
  {
    icon: <EnvelopeIcon />,
    label: 'Email',
    links: [
      { text: <>creativefreightwaylogistics<br />@gmail.com</>, href: 'mailto:creativefreightwaylogistics@gmail.com' }
    ],
    bg: '#EA4335', color: 'white'
  },
];

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <div className="contact-grid">
          {contactCards.map(card => (
            <div className="contact-card" key={card.label}>
              <div className="contact-card-icon" style={{ background: card.bg, color: card.color }}>
                {card.icon}
              </div>
              <h3>{card.label}</h3>
              <div className="contact-card-links">
                {card.links.map((link, idx) => (
                  <a key={idx} href={link.href} target="_blank" rel="noopener noreferrer" className="contact-link">
                    {link.text}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── FOOTER ──────────────────────────────────────────────────────────────────
function Footer() {
  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'Services', href: '#services' },
    { label: 'How it works', href: '#how-it-works' },
    { label: 'Why choose us', href: '#why-choose' },
    { label: 'Notices', href: '#notices' },
    { label: 'Contact Us', href: '#contact' },
  ];
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand-col">
            <div className="footer-brand" style={{ marginBottom: '24px' }}>
              <img src="/Logo.png" alt="Company Logo" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span className="footer-brand-name">Creative FreightWay<br />Logistics Pvt Ltd</span>
            </div>
            <div className="footer-links-grid">
              <div className="links-group">
                {quickLinks.slice(0, 3).map((link) => (
                  <a key={link.href} href={link.href}>{link.label}</a>
                ))}
              </div>
              <div className="links-group">
                {quickLinks.slice(3).map((link) => (
                  <a key={link.href} href={link.href}>{link.label}</a>
                ))}
              </div>
            </div>
          </div>
          <div className="footer-contact-col">
            <h4>CONTACT US</h4>
            <div className="footer-contact-item">+94 71 205 5774</div>
            <div className="footer-contact-item">+94 71 123 4567</div>
            <div className="footer-contact-item">creativefreightwaylogistics@gmail.com</div>
            <div className="footer-contact-item">
              25A/1, Thoranawila junction, Makandana,<br />
              Kesbewa, Piliyandala, Colombo
            </div>
            <div className="footer-social-links">
              <a href="https://facebook.com/Freightway" target="_blank" rel="noopener noreferrer" className="footer-social-icon fb">
                <FacebookIcon />
              </a>
              <a href="https://www.instagram.com/creativefreightwaylogistics?igsh=a3BuaGJmMnoyNTl4" target="_blank" rel="noopener noreferrer" className="footer-social-icon ig">
                <InstagramIcon />
              </a>
              <a href="https://www.tiktok.com/@creative_freightwaylogis?_r=1&_t=ZS-94Bn3C0xZNE" target="_blank" rel="noopener noreferrer" className="footer-social-icon tt">
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Creative FreightWay Logistics Pvt Ltd. All rights reserved.
      </div>
    </footer>
  );
}

// ─── SCROLL TO TOP ────────────────────────────────────────────────────────────
function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
}

// ─── APP ROOT ─────────────────────────────────────────────────────────────────
function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <SpecialNotices />
      <Services />
      <HowItWorks />
      <WhyChooseUs />
      <Gallery />
      <OfficeMap />
      <FAQ />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
